module.exports = __webpack_public_path__ + "static/media/recommended-2.00e62111.png";